export default "__VITE_ASSET__KECTwil7__"